import { BasePaginationButton } from './base-pagination-button'

export const Separator = () => {
  return <BasePaginationButton disabled={true}>...</BasePaginationButton>
}
